import { Store } from "../../@core/store/store";

export class FilterLoadingState extends Store.AbstractLoadingState<any> {}
export class FilterLoadingErrorState extends Store.AbstractErrorState<any> {}
export class FilterLoadedState extends Store.AbstractIdealState<any> {}

export class MoodLoadingState extends Store.AbstractLoadingState<any> {}
export class MoodLoadingErrorState extends Store.AbstractErrorState<any> {}
export class MoodLoadedState extends Store.AbstractIdealState<any> {}

export class LineChartLoadingState extends Store.AbstractLoadingState<any> {}
export class LineChartLoadingErrorState extends Store.AbstractErrorState<any> {}
export class LineChartLoadedState extends Store.AbstractIdealState<any> {}